import React from 'react';
import { FaFacebook, FaInstagram, FaTelegram, FaTwitter, FaYoutube } from 'react-icons/fa';

export const socialLinks = [
  {
    name: 'youtube',
    url: 'https://www.youtube.com/@DRSHKHADARXASANAXMED',
    icon: <FaYoutube />,
  },
  {
    name: 'instagram',
    url: 'https://t.me/drkhadarxasan',
    icon: <FaTelegram />,
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/drkhadarxasan/',
    icon: <FaFacebook />,
  },
  {
    name: 'twitter',
    url: 'https://twitter.com/',
    icon: <FaTwitter />,
  },
];
